import { MyNotificationsProvider } from '@/context/MyNotificationsContext'
import { WrapperProps } from '@/shared/routes'

import NotificationsLayout from './NotificationsLayout'

/**
 * UserMyNotifications Component
 *
 * This component serves as the main wrapper for the Notifications page.
 */
export default function UserMyNotifications(props: WrapperProps) {
  return (
    <MyNotificationsProvider>
      <NotificationsLayout {...props} />
    </MyNotificationsProvider>
  )
}
